// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import vuetify from '@/plugins/vuetify';
import moment from 'moment';
import Vuelidate from 'vuelidate';
import VueI18n from 'vue-i18n';
import messages from '@/i18n/messages';
import VueExcelXlsx from 'vue-excel-xlsx';
import store from './store';
import router from './router';
import App from './App';

import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuelidate);
Vue.use(VueI18n);
Vue.use(VueExcelXlsx);

const i18n = new VueI18n({
  locale: 'es',
  messages,
});

Vue.config.productionTip = false;

Vue.filter('date', (val) => moment(val).format('DD-MMM-YYYY'));

Vue.filter('datetime', (val) => moment(val).format('DD-MMM-YYYY h:mm:ss a'));

Vue.filter('number', (value) => {
  if (!value) {
    return '0.00';
  }
  return Number(value).toFixed(2);
});

export const bus = new Vue();
export default bus;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  vuetify,
  i18n,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js